<template>
  <div class="StockConfig-page" ref="container">
		<div class="info-content">
			<div class="info-box">
				<div class="info-box-content">
					<div class="info-box-label">
						<div class="label-name">设备名称</div>
						<div class="label-value"><input type="input" v-model="deviceInfo.name" placeholder="请填写设备名称"/></div>
					</div>
					<div class="info-box-label" @click="citySelect()">
						<div class="label-name">设备城市</div>
						<div class="label-value" v-if="deviceInfo.address">{{deviceInfo.address}}</div>
						<div class="label-value" v-else>请选择</div>
						<div class="iconfont icon-xiangyou"></div>
					</div>
					<div class="info-box-label">
						<div class="label-name">详细地址</div>
						<div class="label-value"><input type="input" v-model="deviceInfo.detailed_address" placeholder="请填写详细地址"/></div>
					</div>
				</div>
			</div>
		</div>
	
		<CitySelect
		  ref="cityselect"
		  v-model="citySelectShow"
		  :callback="cityChange"
		  :items="district"
		  :ready="ready"
		  provance=""
		  city=""
		  area=""
		></CitySelect>
		
		<div class="btnView">
			<div class="btn btn-save" @click="save">保存</div>
		</div>
		
	</div>
</template>
<script>
import PetApi from "../../api/petAdmin";
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import { petGetCity } from "@api/public";
import axios from "axios";
export default {
  name: "PetAdminDeviceConfig",
  components: {
		CitySelect
	},
  props: {},
  data: function() {
    return {
			deviceInfo : {
				name : '',
				address : '',
				detailed_address : ''
			},
			citySelectShow : false,
			district : [],
			ready : false,
			
			status : 0,
			open : true,
			orderInfo : {},
			deviceSn: this.$route.params.deviceSn,
    };
  },
  watch: {
    "$route.params": function(newVal) {
      var that = this;
      if (newVal != undefined) {
      }
    }
  },
  mounted: function() {
		this.getCityList();
		this.getInfo();
  },
  computed: {},
  methods: {
		save() {
			let that = this;
			PetApi.petDeviceInfoSave({deviceSn : that.deviceSn, info : that.deviceInfo}).then(
			  res => {
					that.$dialog.message(res.msg);
			  },
			  error => {
			    that.$dialog.message(error.msg);
			  }
			);
		},
		getInfo() {
			let that = this;
			PetApi.petDeviceInfo(that.deviceSn).then(
			  res => {
					that.deviceInfo = res.data;
			  },
			  error => {
			    that.$dialog.message(error.msg);
			  }
			);
		},
		getCityList: function() {
		  let that = this;
		  petGetCity().then(res => {
				that.district = res.data;
				that.ready = true;
			})
			.catch(err => {
				that.$dialog.error(err.msg);
			});
		},
		cityChange(value) {
			this.deviceInfo.address = value.itemName1 + "," + value.itemName2
			console.log(value)
		},
		citySelect() {
			this.citySelectShow = true;
		},
		changeclose() {
			this.open = false;
		},
		edit() {
			this.open = true;
		},
		
		search(filter) {
			this.$refs.list.reload(filter);
		},
		reload() {
			
		},
		moreInfo() {
			console.log('moreInfo')
		}
  }
};
</script>
<style lang="scss">
body {background: #F9F9F9 !important;}
.StockConfig-page {
	
	.info-content {
		padding: 0 0.32rem;
		.info-box {
			background: #FFFFFF;
			border-radius: .20rem;
			margin-top: 0.48rem;
			position: relative;
	
			.info-box-content {
				padding: 0 0.3rem;
				
				.info-box-label {
					display: flex;
					justify-content: space-between;
					height: 1rem;
					align-items: center;
					
					&:not(:last-child) {
						border-bottom: 0.02rem solid #E8E8E8;
					}
					
					
					.label-name {
						font-weight: 400;
						font-size: .28rem;
						color: #000000;
						width: 1.5rem;
					}
					.label-value {
						font-weight: 400;
						font-size: .28rem;
						color: #999999;
						text-align: left;
						flex: 1;
					}
					
					.iconfont {
						font-weight: 600;
						font-size: 0.28rem;
						margin-left: 0.12rem;
						color: #888888;;
					}
				}
			}
		}
	}
	
	.btnView {
		width: 100%;
		position: fixed;
		bottom : 1rem;
		padding: 0 0.32rem;
		.btn {
			height: 1rem;
			line-height: 1rem;
			background: #F5A100;
			border-radius: .50rem;
			text-align: center;
			color : #fff;
			font-weight: 400;
			font-size: .34rem;
			
			.btn-save {
				
			}
		}
	}
}

</style>
